import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "@/services";
import { routes } from "@/routes/utils";
import { getRequiredFields, removeEmptyFields } from "@/lib/utils";
import { schema } from "./validations";
import { EMAIL_ID } from "./consts";
import { setForgotPwdEmail } from "@/redux/slices";
import { useDispatch } from "react-redux";
import { toast } from "@/components";

const useChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useForm<any>({
    defaultValues: {
      [EMAIL_ID]: "",
    },
    resolver: zodResolver(schema),
  });

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const { mutate: forgotPasswordInfo, isPending: isForgotPasswordPending } =
    useForgotPasswordMutation({
      onError: (error?: any) => {
        toast({
          message:
            typeof error?.response?.data?.message === "string"
              ? error?.response?.data?.message
              : "Something went wrong",
          type: "error",
        });
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        navigate(`/${routes.resetPasswordOtp}`);
        toast({ message: "OTP sent to your email address" });
        dispatch(setForgotPwdEmail(form.watch(EMAIL_ID)));
      },
    });

  const onSubmit = (data: any) => {
    const _data = removeEmptyFields(data);

    forgotPasswordInfo({ data: _data });
  };

  return {
    navigate,
    form,
    requiredFields,
    onSubmit,
    isForgotPasswordPending,
  };
};

export default useChangePassword;
